import React, { useContext, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import axios from "axios";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
const UserShortLinks = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [leaveCount, setLeaveCount] = useState(0);
  const [hostelAccess, setHostelAccess] = useState(0);
  const [circularCount, setCircularCount] = useState(0);
  /*   useEffect(() => {
    loadData();
  }, []); */

  /*   const loadData = () => {
    const form = new FormData();
    form.append("type", "staff");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.emp_academic_department);
    form.append("role", context.user.emp_role_id);
    form.append("emp_id", context.user.id);

    context.allowedAccess("mob_allow_circular", "action_list") &&
      axios.post(ServiceUrl.MOB.ANNOUNCEMENT_STAFF_COUNT, form).then((res) => {
        if (res["data"].status == "1") {
          setCircularCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
        }
        setLoader(false);
      });
  }; */

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };

  const shortMenus = () => {
    let rv = [];
    if (context.allowedAccess("mob_student_attendance", "action_create")) {
      rv.push(
        {
          icon: MOB_ICONS.MARKED_LIST_IMG,
          text: "Marked List",
          to: "/staff/app/my-att-report",
        },
        {
          icon: MOB_ICONS.TIMETABLE_IMG,
          text: "Time Table",
          to: "/staff/app/my-timetable",
        }
      );
    }
    if (
      context.allowedAccess(
        "allow_staff_in_mobile_general_att_entry",
        "action_create"
      )
    ) {
      rv.push({
        icon: MOB_ICONS.GENERAL_ENTRY_IMG,
        text: "General Entry",
        to: "/staff/app/custom-attendance-entry",
      });
    }
    if (context.allowedAccess("mob_elective_atttendance", "action_create")) {
      rv.push({
        icon: MOB_ICONS.NME_SBE_ENTRY_IMG,
        text: "NME,SBE Entry",
        to: "/staff/app/custom-attendance-entry/elective",
      });
    }

    if (
      context.allowedAccess("mob_staff_stu_hostel_attendance", "action_list")
    ) {
      rv.push({
        icon: MOB_ICONS.HOSTEL_512,
        text: "Hostel Attendance",
        to: "/staff/app/custom-attendance-entry/elective",
      });
    }

    rv.push({
      icon: MOB_ICONS.MY_PROFILE_IMG,
      text: "My Profile",
      to: "/staff/app/myprofile",
      className: "d-none d-sm-block",
    });
    if (
      context.allowedAccess("mob_staff_allow_class_monitoring", "action_list")
    ) {
      rv.push({
        icon: MOB_ICONS.CLASS_MONITORING,
        text: "Class Monitoring",
        to: "/staff/app/class-monitoring",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_student__ser_attendance", "action_list")) {
      rv.push({
        icon: MOB_ICONS.SERVICEATTENDANCE,
        text: "Service Organization Attendance",
        to: "/staff/app/serviceorganization-attendance",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_staff_allow_events", "action_list")) {
      rv.push({
        icon: MOB_ICONS.EVENTS,
        text: "Event",
        to: "/staff/app/events",
        className: "d-none d-sm-block",
      });
    }

    if (
      context.allowedAccess(
        "mob_allow_view_dept_pending_attendance",
        "action_read"
      )
    ) {
      rv.push({
        icon: MOB_ICONS.VIEWPENDING,
        text: "View Pendings",
        to: "/staff/app/atttendance-pending-list",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_att_special_entry", "action_create")) {
      rv.push({
        icon: MOB_ICONS.SPLENTRY,
        text: "Special Entry",
        to: "/staff/app/custom-attendance-entry/special",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_allow_library_search", "action_list")) {
      rv.push({
        icon: MOB_ICONS.LIBRARY,
        text: "Library",
        to: "/staff/app/library",
        className: "d-none d-sm-block",
      });
    }
    if (
      context.allowedAccess("mob_staff_allow_leave_requests", "action_create")
    ) {
      rv.push({
        icon: MOB_ICONS.LEAVE_IMG,
        text: "Leave Availment",
        to: "/staff/app/myleaves",
        className: "d-none d-sm-block",
      });
    }
    if (context.allowedAccess("mob_college_circular_list", "action_create")) {
      rv.push({
        icon: MOB_ICONS.CIRCULAR,
        text: "College Circular",
        to: "/staff/app/collegecircular",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_staff_allow_permission", "action_create")) {
      rv.push({
        icon: MOB_ICONS.PERMISSION_BUTTON,
        text: "Permission Availment",
        to: "/staff/app/permission",
        className: "d-none d-sm-block",
      });
    }

    if (
      context.allowedAccess("mob_staff_allow_odpermission", "action_create")
    ) {
      rv.push({
        icon: MOB_ICONS.ODPERMISSION_BUTTON,
        text: "OD Permission Availment",
        to: "/staff/app/odpermission",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_allow_circular", "action_list")) {
      rv.push({
        icon: MOB_ICONS.CIRCULAR,
        text: "Circular",
        to: "/staff/app/circular",
        className: "d-none d-sm-block",
        count: circularCount,
      });
    }
    if (context.allowedAccess("mob_allow_hostel_attendance", "action_list")) {
      rv.push({
        icon: MOB_ICONS.HOSTEL_512,
        text: "Hostel",
        to: "/staff/app/hostel-attendance",
        className: "d-none d-sm-block",
      });
    }
    if (context.allowedAccess("mob_student_profile_view", "action_list")) {
      rv.push({
        icon: MOB_ICONS.STUDENT_SEARCH,
        text: "Student Search",
        to: "/staff/app/student-search",
        className: "d-none d-sm-block",
      });
    }
    if (context.allowedAccess("mob_allow_staff_attendance", "action_list")) {
      rv.push({
        icon: MOB_ICONS.STAFF_ATTENDANCE,
        text: "Staff Attendance",
        to: "/staff/app/staff-attendance",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_staff_profile", "action_create")) {
      rv.push({
        icon: MOB_ICONS.STAFF_PROFILE,
        text: "Staff Profile",
        to: "/staff/app/staffprofile",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_allow_task_management", "action_list")) {
      rv.push({
        icon: MOB_ICONS.TASK_512,
        text: "Task",
        to: "/staff/app/task-management",
        className: "d-none d-sm-block",
      });
    }

    if (context.allowedAccess("mob_allow_estblishment", "action_list")) {
      rv.push({
        icon: MOB_ICONS.ESTABLISHMENT,
        text: "Establishment",
        to: "/staff/app/establishment",
        className: "d-none d-sm-block",
      });
    }
    if (context.allowedAccess("mob_allow_payslip", "action_list")) {
      rv.push({
        icon: MOB_ICONS.PAYSLIP,
        text: "Pay Slip",
        to: "/staff/app/payslip",
        className: "d-none d-sm-block",
      });
    }
    return rv;
  };

  /*[
    {
      icon: MOB_ICONS.GEN_ATT_ENTRY_256,
      text: "Gen Entry",
      to: "/app/custom-attendance-entry",
    },
    {
      icon: MOB_ICONS.ADD_WITH_PAD_COLOR_256,
      text: "Special Entry",
      to: "/app/custom-attendance-entry/special",
    },
    {
      icon: MOB_ICONS.ATT_REPORT_256,
      text: "Marked List",
      to: "/app/my-att-report",
    },
    {
      icon: MOB_ICONS.TIMETABLE_256,
      text: "Timetable",
      to: "/app/my-timetable",
    },
  ];*/
  return (
    <>
      <div class="row g-1 rtl-flex-d-row-r ">
        {shortMenus().map((item) => (
          <Col xs={4} sm={4} md={3} className={item.className || "txt"}>
            <a onClick={(e) => linkClick(item.to)}>
              <Card className="shadow-none menu-card">
                <CardContent
                  className="p-0 rounded"
                  style={{
                    height: "70px",
                    whiteSpace: "nowrap",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography
                    className="mt-2"
                    sx={{
                      color: "text.secondary",
                      fontSize: 14,
                      display: "flex", // Flexbox for centering
                      justifyContent: "center", // Horizontal centering
                      alignItems: "center", // Vertical centering
                    }}
                  >
                    {item.to == "/staff/app/myleaves" ? (
                      <img
                        src={item.icon}
                        style={{ width: "37px", marginLeft: "10px" }}
                      />
                    ) : (
                      <img src={item.icon} style={{ width: "30px" }} />
                    )}
                    <br />
                  </Typography>
                  <div className="text-center text-black mt-2">{item.text}</div>
                </CardContent>
              </Card>
            </a>
          </Col>
        ))}
      </div>
    </>
  );
  return (
    <>
      <div class="row g-2 rtl-flex-d-row-r py-3">
        {shortMenus().map((item) => (
          <Col
            xs={6}
            sm={6}
            md={4}
            data-aos="zoom-in"
            className={item.className || "txt"}
          >
            <a onClick={(e) => linkClick(item.to)}>
              <div className="d-flex justify-content-between bg-white p-2 rounded shadow-sm">
                {item.to == "/staff/app/myleaves" ? (
                  <img
                    src={item.icon}
                    style={{ width: "37px", marginLeft: "10px" }}
                  />
                ) : (
                  <img src={item.icon} style={{ width: "37px" }} />
                )}
                <div className="text-center text-dark pt-2">{item.text}</div>{" "}
                {item.count ? (
                  <span class="notify-count">{item.count}</span>
                ) : (
                  ""
                )}
                {/*item.to == "/staff/app/myleaves" && leaveCount > 0 ? (
                  <span class="float-end bg-danger text-white px-2 py-2 rounded">
                    {leaveCount}
                  </span> 
                ) : (
                  ""
                )*/}
              </div>
            </a>
          </Col>
        ))}
      </div>
    </>
  );
};
export default UserShortLinks;
